const { marked } = require('marked');

const MONTHS = {
  january: 1,
  jan: 1,
  february: 2,
  feb: 2,
  march: 3,
  mar: 3,
  april: 4,
  apr: 4,
  may: 5,
  june: 6,
  jun: 6,
  july: 7,
  jul: 7,
  august: 8,
  aug: 8,
  september: 9,
  sep: 9,
  sept: 9,
  october: 10,
  oct: 10,
  november: 11,
  nov: 11,
  december: 12,
  dec: 12,
};

function processPhoneLinks(text) {
  if (!text) return text;

  const pattern1 = /\((\d{3})\)\s*(\d{3})-(\d{4})/g;
  const pattern2 = /\b(\d{3})-(\d{3})-(\d{4})\b/g;
  let processedText = text;

  processedText = processedText.replace(
    pattern1,
    (match, area, prefix, line) => {
      const phoneNumber = `+1${area}${prefix}${line}`;
      return `<a href="tel:${phoneNumber}">${match}</a>`;
    },
  );

  processedText = processedText.replace(
    pattern2,
    (match, area, prefix, line) => {
      const phoneNumber = `+1${area}${prefix}${line}`;
      return `<a href="tel:${phoneNumber}">${match}</a>`;
    },
  );

  return processedText;
}

function processDateLinks(text) {
  if (!text) return text;

  const monthDayPattern =
    /(January|February|March|April|May|June|July|August|September|October|November|December|Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Sept|Oct|Nov|Dec)\s+(\d{1,2})/gi;
  const slashDatePattern = /\b(\d{1,2})\/(\d{1,2})(?:\/(\d{2,4}))?\b(?!")/g;
  const dashDatePattern =
    /(?<![\d-])(\d{1,2})-(\d{1,2})(?:-(\d{2,4}))?(?![\d-])/g;

  let processedText = text;

  processedText = processedText.replace(
    monthDayPattern,
    (match, monthStr, day) => {
      const month = MONTHS[monthStr.toLowerCase()];
      const currentYear = new Date().getFullYear();
      return `[${match}](#calendar-${month}-${currentYear}-${day})`;
    },
  );

  processedText = processedText.replace(
    slashDatePattern,
    (match, month, day, year) => {
      const fullYear = year
        ? year.length === 2
          ? 2000 + parseInt(year, 10)
          : parseInt(year, 10)
        : new Date().getFullYear();
      return `[${match}](#calendar-${month}-${fullYear}-${day})`;
    },
  );

  processedText = processedText.replace(
    dashDatePattern,
    (match, month, day, year) => {
      const fullYear = year
        ? year.length === 2
          ? 2000 + parseInt(year, 10)
          : parseInt(year, 10)
        : new Date().getFullYear();
      return `[${match}](#calendar-${month}-${fullYear}-${day})`;
    },
  );

  return processedText;
}

function processTableCentering(text) {
  const lines = text.split('\n');
  const processedLines = [];

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];

    if (line.includes('|') && i + 1 < lines.length) {
      const nextLine = lines[i + 1];

      if (nextLine.includes('|') && nextLine.includes('-')) {
        const headerCells = line.split('|');
        const separatorCells = nextLine.split('|');
        const processedHeaderCells = [];
        const processedSeparatorCells = [];

        for (let j = 0; j < headerCells.length; j++) {
          let headerCell = headerCells[j];
          let separatorCell = separatorCells[j] || '';
          let widthStyle = '';

          if (headerCell.trim().startsWith('^^')) {
            headerCell = headerCell.replace(/^\s*\^\^\s*/, '');
            widthStyle = 'style="width: 34%;"';
          } else if (headerCell.trim().startsWith('^')) {
            headerCell = headerCell.replace(/^\s*\^\s*/, '');
            widthStyle = 'style="width: 17%;"';
          }

          if (headerCell.trim().startsWith('@')) {
            headerCell = headerCell.replace(/^\s*@\s*/, '');
            const trimmedSeparator = separatorCell.trim();
            if (trimmedSeparator.includes('-')) {
              const dashCount = Math.max(3, trimmedSeparator.length);
              separatorCell = separatorCell.replace(
                trimmedSeparator,
                ':' + '-'.repeat(dashCount - 2) + ':',
              );
            }
          }

          if (widthStyle) {
            headerCell = `${headerCell}<!--width:${widthStyle}-->`;
          }

          processedHeaderCells.push(headerCell);
          processedSeparatorCells.push(separatorCell);
        }

        processedLines.push(processedHeaderCells.join('|'));
        processedLines.push(processedSeparatorCells.join('|'));
        i++;
      } else {
        processedLines.push(line);
      }
    } else {
      processedLines.push(line);
    }
  }

  return processedLines.join('\n');
}

function applyTableWidthStyles(html) {
  return html.replace(
    /<th([^>]*)>([^<]*?)<!--width:(style="[^"]*")-->/g,
    '<th $3 $1>$2',
  );
}

function withWorkOrderSearchColon(href) {
  return String(href || '').replace(
    /(mworkorders\?search=)(?!:)(\d+)/i,
    '$1:$2',
  );
}

function chipWorkOrderLinks(html) {
  return String(html || '').replace(/<a\b([^>]*?)>/gi, (full, attrs) => {
    const hrefMatch = attrs.match(/\shref\s*=\s*(?:"([^"]*)"|'([^']*)')/i);
    const rawHref = hrefMatch ? hrefMatch[1] || hrefMatch[2] || '' : '';
    const href = withWorkOrderSearchColon(rawHref);
    if (!/mworkorders\?search=:\d+/i.test(href)) return full;
    let next = attrs;
    if (rawHref && href !== rawHref) next = attrs.replace(rawHref, href);
    if (/\bnote-wo-chip\b/.test(next)) return `<a${next}>`;
    if (/\sclass\s*=\s*"/i.test(next)) {
      return `<a${next.replace(/\sclass\s*=\s*"/i, ' class="note-wo-chip ')}>`;
    }
    if (/\sclass\s*=\s*'/i.test(next)) {
      return `<a${next.replace(/\sclass\s*=\s*'/i, " class='note-wo-chip ")}>`;
    }
    return `<a class="note-wo-chip"${next}>`;
  });
}

function markdownLinksIn(text) {
  const links = [];
  const re = /\[([^\]\n]+)\]\(([^)\s]+)\)/g;
  let match = re.exec(text);
  while (match) {
    links.push({ label: match[1], url: match[2] });
    match = re.exec(text);
  }
  return links;
}

function uniqueMarkdownLinks(links) {
  const seen = new Set();
  const out = [];
  for (const link of links) {
    const key = `${link.label}\n${link.url}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(link);
  }
  return out;
}

function briefingSourceTexts(line, sources) {
  const byId = new Map();
  const pairs =
    sources instanceof Map ? sources.entries() : Object.entries(sources || {});
  for (const [id, text] of pairs) {
    byId.set(String(id), String(text || ''));
  }
  const ids = [...String(line).matchAll(/search=:(\d+)/g)].map((match) => match[1]);
  if (ids.length) {
    return ids.map((id) => byId.get(id)).filter(Boolean);
  }
  return [...byId.values()].filter(Boolean);
}

function ellipsisCut(line) {
  const uni = line.lastIndexOf('\u2026');
  const dots = line.lastIndexOf('...');
  if (uni === -1 && dots === -1) return null;
  if (uni === -1) return { index: dots, length: 3 };
  if (dots === -1) return { index: uni, length: 1 };
  return uni > dots
    ? { index: uni, length: 1 }
    : { index: dots, length: 3 };
}

function openMarkdownLink(head) {
  const start = head.lastIndexOf('[');
  if (start < 0) return null;
  const after = head.slice(start);
  const labelEnd = after.indexOf(']');
  if (labelEnd === -1) {
    const label = after.slice(1);
    if (!label) return null;
    return { start, kind: 'label', label };
  }
  const rest = after.slice(labelEnd + 1);
  if (!rest.startsWith('(') || rest.includes(')')) return null;
  return {
    start,
    kind: 'url',
    label: after.slice(1, labelEnd),
    urlPrefix: rest.slice(1),
  };
}

function chooseTruncatedLink(open, texts) {
  const pool = uniqueMarkdownLinks(texts.flatMap((text) => markdownLinksIn(text)));
  if (open.kind === 'url') {
    return uniqueOrNull(
      pool.filter(
        (link) =>
          link.label === open.label &&
          (link.url === open.urlPrefix || link.url.startsWith(open.urlPrefix)),
      ),
    );
  }
  return uniqueOrNull(pool.filter((link) => link.label.startsWith(open.label)));
}

function uniqueOrNull(links) {
  const unique = uniqueMarkdownLinks(links);
  return unique.length === 1 ? unique[0] : null;
}

function repairTruncatedMarkdownLine(line, sources) {
  let next = String(line);
  for (let guard = 0; guard < 5; guard += 1) {
    const cut = ellipsisCut(next);
    if (!cut) return next;
    const open = openMarkdownLink(next.slice(0, cut.index));
    if (!open) return next;
    const link = chooseTruncatedLink(open, briefingSourceTexts(next, sources));
    if (!link) return next;
    const full = `[${link.label}](${link.url})`;
    const repaired =
      next.slice(0, open.start) + full + next.slice(cut.index + cut.length);
    if (repaired === next) return next;
    next = repaired;
  }
  return next;
}

function repairTruncatedMarkdownLinks(text, sources) {
  return String(text || '')
    .split('\n')
    .map((line) => repairTruncatedMarkdownLine(line, sources))
    .join('\n');
}

function renderNoteMarkdown(noteBody) {
  if (!noteBody) return '';

  try {
    marked.setOptions({
      gfm: true,
      tables: true,
      breaks: false,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: false,
    });

    let processedNoteBody = String(noteBody);
    processedNoteBody = processDateLinks(processedNoteBody);
    processedNoteBody = processPhoneLinks(processedNoteBody);
    processedNoteBody = processedNoteBody.replace(
      /\[DONE\]/gi,
      '<span class="done-checkmark">✓</span>',
    );
    processedNoteBody = processTableCentering(processedNoteBody);
    const markdown = marked.parse(processedNoteBody);
    return chipWorkOrderLinks(applyTableWidthStyles(markdown));
  } catch (error) {
    console.error('Error parsing markdown:', error);
    return String(noteBody);
  }
}

module.exports = {
  renderNoteMarkdown,
  chipWorkOrderLinks,
  repairTruncatedMarkdownLinks,
};
